import { Component, Inject } from "@angular/core";
import { BV_DIALOG_DATA, BvDialogRef } from "../../design-system";

import { BvDialogTitleComponent, BvDialogBodyComponent, BvDialogFooterComponent } from "../../design-system/primitives/dialog.component";
import { BvFormFieldComponent } from "../../design-system/primitives/form-field.component";
import { BvInputDirective } from "../../design-system/primitives/input.directive";
import { FormsModule } from "@angular/forms";
import { BvButtonComponent } from "../../design-system/primitives/button.component";

export interface PromptDialogData {
  title?: string;
  message: string;
  value?: string;
  acceptButton?: string;
  cancelButton?: string;
}

@Component({
    selector: "app-prompt-dialog",
    templateUrl: "./prompt-dialog.component.html",
    styleUrls: ["./prompt-dialog.component.scss"],
    imports: [BvDialogTitleComponent, BvDialogBodyComponent, BvFormFieldComponent, BvInputDirective, FormsModule, BvDialogFooterComponent, BvButtonComponent]
})
export class PromptDialogComponent {
  inputValue: string = "";

  constructor(
    public dialogRef: BvDialogRef<PromptDialogComponent>,
    @Inject(BV_DIALOG_DATA) public data: PromptDialogData
  ) {
    this.inputValue = data.value || "";
  }

  onConfirm(): void {
    this.dialogRef.close(this.inputValue);
  }

  onCancel(): void {
    this.dialogRef.close(null);
  }
}